import { postRequestFileDownload, restApiRequest, restApiRequestPost, getErrorMessage } from './ajax'
import saveAs from 'file-saver'

const creativeReportPlus = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * フィルタ条件を取得する
     * @param {*} params
     */
    getFilterList: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL
        restApiRequest(baseURL, `/api/creativereport/cpm/filter/${params.privateCode}/${params.agencyId}/${params.advertiserId}`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              resolve(pluckData(result))
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    getCreativeReport: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL

        restApiRequestPost(baseURL, `/api/creativereport/cpm/report`, params.jwtToken, params)
          .then(result => {
            if (result.status === 200) {
              resolve(pluckData(result))
            } else {
              reject(new Error('Irregular Error.'))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
    },
    getCsvDownload: function({ commit }, params) {
      return new Promise((resolve, reject) => {
        const baseURL = process.env.BaseURL

        postRequestFileDownload(baseURL, `/csv/creativereport-download/cpm/report`, params.jwtToken, params)
          .then(response => {
            const blob = new Blob([response.data], {
              type: response.data.type
            })
            if (response.status === 200) {
              // レスポンスヘッダから csv ファイル名を取得
              const contentDisposition = response.headers['content-disposition']
              const fileName = getFileName(contentDisposition)
              saveAs(blob, fileName)
              resolve(response.data)
            } else {
              reject(new ReferenceError(getErrorMessage('system error')))
            }
          })
          .catch(err => {
            if (!err) {
              resolve(undefined)
              return
            } else if (!err.response) {
              reject(new ReferenceError('commons.restapi.system.error'))
              return
            } else if (err.response.data.errorCode === 'permission.expiration.error') {
              reject(new Error(getErrorMessage(err.response.data.errorCode)))
              return
            }
            reject(new ReferenceError(getErrorMessage(err.response.data.errorCode)))
          })
      })
      function getFileName(contentDisposition) {
        let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length)
        // デコードするとスペースが"+"になるのでスペースへ置換
        fileName = decodeURI(fileName).replace(/\+/g, ' ')
        return fileName
      }
    }
  }
}

function pluckData(response) {
  return response.data
}

export default creativeReportPlus
